export default __webpack_public_path__ + "static/media/profile-pic.5a1c7988.jpg";